import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { push } from 'react-router-redux';
import logo from '../../../../public/catch-logo.png';

import LoginLayout from './LoginLayout';
import LoginForm from './LoginForm';
import RecoverLogin from './RecoverLogin';
import { Modal } from 'react-bootstrap';

import * as actionCreators from '../../../actions/auth';
var NotificationSystem = require('react-notification-system');

class LoginView extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    isAuthenticating: PropTypes.bool.isRequired,
    statusText: PropTypes.string,
    actions: PropTypes.shape({
      authLoginUser: PropTypes.func.isRequired,
    }).isRequired,
    location: PropTypes.shape({
      query: PropTypes.object.isRequired,
    }),
  };

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.handleShowTermsAndCondition = this.handleShowTermsAndCondition.bind(this);
    this.handleShowPrivacyPolicy = this.handleShowPrivacyPolicy.bind(this);
    this.handleClose = this.handleClose.bind(this);

    const redirectRoute = this.props.location ? this.props.location.query.next || '/' : '/'; 1
    this.state = {
      redirectTo: redirectRoute,
      show: false,
    };
  }

  componentWillMount() {
    if (this.props.isAuthenticated) {
      this.props.dispatch(push('/'));
    }
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }
  handleSubmit(values) {
    if (values) {
      if (values.is_terms_accepted) {
        this.props.actions.authLoginUser(values.email, values.password, values.is_terms_accepted, this.state.redirectTo);
      } else {
        this._notificationSystem.addNotification({
          message: 'Please accept the Terms and Conditions',
          level: 'error'
        });
      }
    }
  }

  handleShowTermsAndCondition() {
    this.modalLabel = 'Terms of use';
    this.pdfFileUrl = '/termAndConditionDocument/CatchServicesAgreement.pdf';
    this.setState({ show: true });
  }

  handleShowPrivacyPolicy() {
    this.modalLabel = 'Privacy Policies';
    this.pdfFileUrl = '/termAndConditionDocument/CatchPrivacyPolicy.pdf';
    this.setState({ show: true });
  }

  handleClose() {
    this.setState({ show: false });
  }

  renderRecover() {
    return (
      <LoginLayout>
        <RecoverLogin />
      </LoginLayout>
    );
  }
  render() {
    if (this.props.detail === 'recover') {
      return this.renderRecover();
    }
    let statusText = null;
    if (this.props.statusText) {
      const statusTextClassNames = classNames({
        alert: true,
        'alert-danger': this.props.statusText.indexOf('Authentication Error') === 0,
        'alert-success': this.props.statusText.indexOf('Authentication Error') !== 0,
      });

      statusText = (
        <div className="row">
          <div className="col-sm-12">
            <div className={statusTextClassNames}>{this.props.statusText}</div>
          </div>
        </div>
      );
    }
    return (



      <LoginLayout>

        <NotificationSystem ref="notificationSystem" />
        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{this.modalLabel}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <iframe src={this.pdfFileUrl} width="570px" height="400px"></iframe>
          </Modal.Body>
          <Modal.Footer />
        </Modal>

        <div className="center-block-inner">
          <img src={logo} alt="Catch" />
        </div>
        <div style={{ padding: '60px 40px 60px 40px' }}>
          <h4 className="text-left">Welcome to group travel simplified</h4>
          <br />
          <div className="login-container margin-top-medium">
            {statusText}
            <LoginForm

              onSubmit={this.handleSubmit}
              handleShowTermsAndCondition={this.handleShowTermsAndCondition}
              handleShowPrivacyPolicy={this.handleShowPrivacyPolicy}
            />
          </div>
        </div>
      </LoginLayout>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  isAuthenticated: state.auth.isAuthenticated,
  isAuthenticating: state.auth.isAuthenticating,
  statusText: state.auth.statusText,
  detail: ownProps.params.key,
});

const mapDispatchToProps = dispatch => ({
  dispatch,
  actions: bindActionCreators(actionCreators, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginView);
export { LoginView as LoginViewNotConnected };



// WEBPACK FOOTER //
// src/routes/login/containers/Login.js